import moment from "moment";
require('moment-timezone');

const {openingTime, closingTime} = dataLayer[0];

$(document).ready(function () {
  /* Moment */
  moment.locale('es');
  
  function set_date_in_timezone(date, timezone, cod_country) {
    var date_in_timezone = moment.tz(date, timezone).format('D') + '/' + moment.tz(date, timezone).format('MMM').toUpperCase();
    date_in_timezone = date_in_timezone.slice(0, -1);
    var fecha_email = moment.tz(date, timezone).format('D') + '/' + moment.tz(date, timezone).format('MMM').toUpperCase();
    fecha_email = date_in_timezone.slice(0, -1);
    var time_in_timezone = moment.tz(date, timezone).format('hh:mm a').replace('.', '');
    var offset = moment.tz(date, timezone).format('Z');
    if (offset.charAt(1) == 0) {
      offset = offset.slice(0, 1) + offset.slice(2);
    }
    offset = "(GMT" + offset + ")";
    return {
      'date_in_timezone': date_in_timezone,
      'time_in_timezone': time_in_timezone,
      'offset': offset,
      'cod_country': cod_country,
      'timezone': timezone,
    }
  }
  /* Moment */

  function attentionSchedule (time, place) {
    var date, offset, timezone_detected;
    timezone_detected = set_date_in_timezone(time, Intl.DateTimeFormat().resolvedOptions().timeZone, "");
    date = moment.tz(time, timezone_detected.timezone).format('hh:mm a');
    offset = moment.tz(time, timezone_detected.timezone).format('Z');
    $(place).html("<b>" + date + "</b> <span>(GMT " + offset + ")</span>");
  }

  // === 6 (Sábado), === 7 (Domingo)
  var validDays = (moment().isoWeekday() === 6 || moment().isoWeekday() === 7) ? false : true;

  function showmodal(validDays, startTime, endTime){
    
    let currentTime = moment(moment(), "HH:mm ZZ"),
    start       = moment(`${startTime} -0300`, "HH:mm ZZ"),
    end         = moment(`${endTime} -0300`, "HH:mm ZZ"),
    validHours  = currentTime.isBetween(start, end);
    
    if(validDays && validHours) return true;
    return false;
  }
  const isOpen = showmodal(validDays, openingTime, closingTime);
  // check days and hours

  /* Contact: Modal whatsapp  */
  if ($('body main').hasClass('contact') && !isOpen) {
    var targetUrl = '';
  
    var hrFrom = $('#attFrom').attr('data-attr-time');
    attentionSchedule(hrFrom, '#attFrom');
  
    var hrTo = $('#attTo').attr('data-attr-time');
    attentionSchedule(hrTo, '#attTo');
    
    $('.link-to-whatsapp, .opt-whatsapp-chat a').on('click', function (e) {
      e.preventDefault();
      targetUrl = $(this).attr("href");
      $('#modal-whatsapp').fadeIn('fast');
    });
    
    $('#modal-whatsapp .close, #modal-whatsapp .button-close').on('click', function (e) {
      e.preventDefault();
      $('#modal-whatsapp').fadeOut('fast');
    });
  
    $('#modal-whatsapp #go').on('click', function () {
      $(this).attr("href", targetUrl);
      $('#modal-whatsapp').fadeOut('fast');
    });
  }
});